<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        회원가입 목록
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">관리</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">회원가입</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_date">가입날짜</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="mb-2 ml-2" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="mb-2" size="sm" variant="primary" @click="set_sd('-1d')">-1일</b-button>
            <b-button class="mb-2" size="sm" variant="primary" @click="set_sd('-1w')">-1주</b-button>
            <b-button class="mb-2" size="sm" variant="primary" @click="set_sd('-1m')">-1월</b-button>
            <b-button class="mb-2" size="sm" variant="primary" @click="set_sd('w')">1주</b-button>
            <b-button class="mb-2" size="sm" variant="primary" @click="set_sd('m')">1월</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.ko" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_last_addr">IP 주소</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center mt-4">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_last_addr" v-model="so.opt['last_addr']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label mb-4" for="opt_username">사용자명</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-label>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_username" v-model="so.opt['username']"></b-form-input>
          </b-form-label>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_Nickname_signup">이름</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_Nickname_signup" v-model="so.opt['nickname']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label mb-4" for="opt_address">주소</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_address" v-model="so.opt['address']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_company">회사</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_company" v-model="so.opt['company']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">일치 유형</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">모두 일치</b-form-radio>
              <b-form-radio value="or">최소 한개이상 일치</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mr-2">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> 찾기 </b-button>
          <b-button size="sm" variant="warning" @click="reset"> 초기화 </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> 닫기 </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col sm="2">
        <span class="badge badge_border_info mb-2">대기 : <span style="padding-left: 2.3rem"></span>{{(model.enable ? model.enable : 0).toString().padStart(4, nbsp) || 0 | number}}</span>
        <br>
        <span class="badge badge_border_warning mb-2">승인 거부 : <span style="padding-left: 0.5rem"></span>{{(model.disable ? model.disable : 0).toString().padStart(4, nbsp) || 0 | number}}</span>
      </b-col>
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || '찾기'" v-model="so.sk" @change="sv_reset">
              <option disabled value="">검색</option>
              <option value="username">이메일</option>
              <option value="nickname">사용자명</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <input type="text" class="form-control col-xl-12" name="input" id="input" v-model="so.sv" @keyup.enter="refresh()">
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1 mt-1"  @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">삭제된 항목 숨기기</b-checkbox>
          </div>
          <div class="mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="15">표시되는 개수 : 기본 15개</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
            :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" @row-clicked="goDetail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | sdate }}</template>
            <template slot="status" slot-scope="row">
              <template v-if="row.item.is_del">
                <i class="fa fa-close" title="deleted user"></i>
              </template>
              <template v-else>
                <i v-if="row.item.is_alive" class="fa fa-envelope-open-o" title="email verified"></i>
                <i v-if="row.item.is_verified" class="fa fa-unlock-alt" title="active user"></i>
                <i v-else class="fa fa-lock" title="inactive user"></i>
              </template>
            </template>
            <template slot="username" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.username}}</del>
              <template v-else>{{row.item.username}}</template>
            </template>
            <template slot="level" slot-scope="row">{{row.item.level | level}}</template>
            <template slot="group.name" slot-scope="row">{{row.item.group && row.item.group.name}}</template>
            <template slot="signup_addr" slot-scope="row">{{row.item.signup_addr }}</template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>